var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fp_postcode" }, [
    _c("input", {
      staticClass: "fp_postcode__input",
      class: { "fp_postcode__input--error": _vm.toggleValidationClass },
      attrs: { name: "postcode", type: "text", placeholder: "Enter postcode" },
      domProps: { value: _vm.value },
      on: {
        input: _vm.updateValue,
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.checkPostcode()
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "firewood_prod__btn_wrap",
        class: { "firewood_prod__btn_wrap--loading": _vm.loading },
      },
      [
        _c(
          "span",
          {
            staticClass: "woo_btn",
            on: {
              click: function ($event) {
                return _vm.checkPostcode()
              },
            },
          },
          [_vm._v("Check")]
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              width: "35",
              height: "35",
              viewBox: "0 0 100 100",
              preserveAspectRatio: "xMidYMid",
            },
          },
          [
            _c("g", { attrs: { transform: "translate(50,50)" } }, [
              _c("g", { attrs: { transform: "scale(0.7)" } }, [
                _c("circle", {
                  attrs: { cx: "0", cy: "0", r: "50", fill: "#e75000" },
                }),
                _c(
                  "circle",
                  { attrs: { cx: "0", cy: "-19", r: "15", fill: "#ffffff" } },
                  [
                    _c("animateTransform", {
                      attrs: {
                        attributeName: "transform",
                        type: "rotate",
                        dur: "1s",
                        repeatCount: "indefinite",
                        keyTimes: "0;1",
                        values: "0 0 0;360 0 0",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "fp_postcode__message",
        class: { "fp_postcode__message--active": _vm.toggleValidationClass },
      },
      [_vm._v(_vm._s(_vm.message))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }